<template>
  <v-container fluid grid-list-md py1>
    <v-layout row wrap>
      <v-flex md12>
        <data-table ref="statusTable" @editRow="load" @auditRow="audit" />
      </v-flex>
    </v-layout>

    <v-layout row wrap class="mb-5">
      <v-flex md12>
        <v-card>
          <v-card-title primary-title class="py-2">
            <v-toolbar-title>{{ $t("view.operativos.status.title") }}</v-toolbar-title>
            <v-spacer />
            <v-btn icon @click="view.elem.showForm = !view.elem.showForm">
              <v-icon>{{ view.elem.showForm ? "keyboard_arrow_down" : "keyboard_arrow_up" }}</v-icon>
            </v-btn>
          </v-card-title>
          <v-expand-transition>
            <v-flex v-show="view.elem.showForm" class="py-0">
              <v-card-text>
                <form onSubmit="return false;" @submit="submit" @keyup.ctrl.83="executeValidators">
                  <v-layout row>
                    <!-- Clave -->
                    <v-flex v-if="status.clave" md12>
                      <v-text-field v-model="status.clave" :label="$t('view.commons.clave')" disabled />
                    </v-flex>

                    <!-- Descripcion -->
                    <v-flex md12>
                      <v-text-field
                        v-model.trim="$v.status.descripcion.$model"
                        :label="$t('view.operativos.status.form.descripcion.label')"
                        :error-messages="getFirstErrorDescription($v.status.descripcion)"
                        maxlength="50"
                        :disabled="view.action.submit.busy"
                        onkeypress="return /^[a-zA-Z0-9\r\.\+\-\_\ ]+$/.test(event.key);" />
                    </v-flex>

                    <!-- Canales -->
                    <v-flex md12>
                      <v-autocomplete
                        v-model.trim="$v.status.canales.$model"
                        :label="$t('view.operativos.status.form.canales.label')"
                        :error-messages="getFirstErrorDescription($v.status.canales)"
                        :items="view.elem.select.canales.filteredList"
                        :disabled="view.action.submit.busy || view.elem.select.canales.disabled"
                        item-value="code"
                        item-text="name"
                        hide-selected
                        deletable-chips
                        clearable
                        multiple
                        small-chips
                        :no-data-text="$t('view.commons.nodata')"
                        @input="search = ''" />
                    </v-flex>

                    <!-- SubStatus -->
                    <v-flex md12>
                      <v-autocomplete
                        v-model.trim="$v.status.substatus.$model"
                        :label="$t('view.operativos.status.form.substatus.label')"
                        :error-messages="getFirstErrorDescription($v.status.substatus)"
                        :items="view.elem.select.substatus.filteredList"
                        :disabled="view.action.submit.busy || view.elem.select.substatus.disabled"
                        item-value="code"
                        item-text="name"
                        hide-selected
                        return-object
                        deletable-chips
                        clearable
                        multiple
                        small-chips
                        :no-data-text="$t('view.commons.nodata')"
                        @input="search = ''">
                        <template #item="data">
                          <v-list-item-content>
                            <v-list-item-title>{{ data.item.code + " " + data.item.name }}</v-list-item-title>
                          </v-list-item-content>
                        </template>
                        <template #selection="data">
                          <v-chip v-bind="data.attrs" :input-value="data.selected" close @click="data.select" @click:close="removeSubstatus(data.item)">
                            {{ data.item.code + " " + data.item.name }}
                          </v-chip>
                        </template>
                      </v-autocomplete>
                    </v-flex>

                    <!-- Permitir Agregador -->
                    <v-flex md3 xl2>
                      <label for="agregador" class="v-label mt-3">{{ $t("view.operativos.status.form.agregador.label") }}</label>
                      <v-switch v-model="status.agregador" input-value="true" color="primary" :disabled="view.action.submit.busy" />
                    </v-flex>

                    <!-- Permitir Merchandising -->
                    <v-flex md3 xl2>
                      <label for="merchandising" class="v-label mt-3">{{ $t("view.operativos.status.form.merchandising.label") }}</label>
                      <v-switch v-model="status.merchandising" input-value="true" color="primary" :disabled="view.action.submit.busy" />
                    </v-flex>

                    <!-- Permitir Exclusiones -->
                    <v-flex md3 xl2>
                      <label for="exclusiones" class="v-label mt-3">{{ $t("view.operativos.status.form.exclusiones.label") }}</label>
                      <v-switch v-model="status.exclusiones" input-value="true" color="primary" :disabled="view.action.submit.busy" />
                    </v-flex>

                    <!-- Mostrar en APP -->
                    <v-flex md3 xl2>
                      <label for="showinapp" class="v-label mt-3">{{ $t("view.operativos.status.form.showinapp.label") }}</label>
                      <v-switch v-model="status.showinapp" input-value="true" color="primary" :disabled="view.action.submit.busy" />
                    </v-flex>

                    <!-- Estatus -->
                    <v-flex md3 xl2>
                      <label for="status" class="v-label mt-3">{{ $t("view.commons.status") }}</label>
                      <v-switch v-model="status.status" input-value="true" color="primary" :disabled="view.action.submit.busy" />
                    </v-flex>
                  </v-layout>
                </form>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-flex shrink>
                  <v-btn
                    v-show="status.clave && $userPermission.hasPermission('ROLE_ACCESO_AUDITORIA')"
                    id="btnaudit"
                    fab
                    small
                    color="primary"
                    class="btn_tippy"
                    elevation="0"
                    :title="$t('view.commons.audit')"
                    :loading="view.action.submit.busy"
                    @click="audit()">
                    <v-icon small>storage</v-icon>
                  </v-btn>

                  <v-btn id="btnclear" fab small color="primary" class="btn_tippy" elevation="0" :title="$t('view.commons.cancel')" :loading="view.action.submit.busy" @click="clear()">
                    <v-icon small>fa-eraser</v-icon>
                  </v-btn>

                  <v-btn
                    v-show="$userPermission.hasPermission('ROLE_MODIFICAR_OP')"
                    id="btnsubmit"
                    fab
                    small
                    color="primary"
                    class="btn_tippy"
                    elevation="0"
                    :title="view.elem.button.submit.title.current"
                    :loading="view.action.submit.busy"
                    :disabled="form.$state.isDisableButtonSubmit()"
                    @click="submit()">
                    <v-icon small>{{ view.elem.button.submit.class.current }}</v-icon>
                  </v-btn>
                </v-flex>
              </v-card-actions>
            </v-flex>
          </v-expand-transition>
        </v-card>
      </v-flex>
    </v-layout>

    <auditoria ref="auditModal" />
  </v-container>
</template>
<script>
import statusStates from "@/views/operativos/status/status-state"; /** *******************************/
import statusAPI from "@/services/operativos/status"; /** *******************************/
import DataTable from "@/views/operativos/status/DataTable"; /** *******************************/
import Auditoria from "@/components/auditoria/Auditoria"; /** *******************************/
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";
import { required } from "vuelidate/lib/validators";
import { fixMigImp } from "@/helpers/vuelidate/validators";
import { allValidatorMethods } from "@/helpers/vuelidate";
import { handleResponse } from "@/helpers/http-response-handler";
import { scrollToForm } from "@/helpers/form-scroll-to";
import { CANALES_SELECT } from "@/constants/operativos";
import { submit } from "@/constants/buttons";
import tippy from "tippy.js";

const select = {
  canales: {
    filteredList: CANALES_SELECT
    , disabled: false
  }
  , substatus: {
    completeList: []
    , filteredList: []
    , disabled: false
  }
};

const action = { submit: { busy: false } };

export default {
  name: "StatusModule"
  , components: {
    DataTable
    , Auditoria
  }
  , data() {
    return {
      status: undefined
      , form: new Object()
      , view: {
        title: this.$t("view.operativos.status.title")
        , action
        , elem: {
          button: { submit }
          , select
          , showForm: true
        }
      }
      , check: true
    };
  }
  , head: {
    title: function () {
      return {
        inner: this.view.title
        , separator: "|"
        , complement: this.$t("view.commons.system")
      };
    }
  }
  , created() {
    this.form = new statusStates(this);
    this.form.$setState("initial");
  }
  , updated() {
    this.$nextTick(function () {
      tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
    });
  }
  , methods: {
    ...allValidatorMethods
    , async submit() {
      try {
        const respuesta = await this.form.$state.submit(this.status);
        handleResponse(respuesta, this.$t("view.operativos.status.errors"));
      } catch (error) {
        handleResponse(error, this.$t("view.operativos.status.errors"));
      }
    }
    , async load(clave) {
      try {
        await this.form.$state.loadSelectsData();
        const response = await statusAPI.get(clave);
        const { data: { results: { status } } } = response;
        this.form.$setState("editing", status);
      } catch (error) {
        console.log(error);
      }
    }
    , async clear() {
      await this.form.$state.askForClear();
      setTimeout(() => document.body.click(), 300);
    }
    , async audit(clave = this.status.clave, dataDescripcion = this.status.descripcion) {
      this.$refs.auditModal.loadAudit(clave, "TStatus", dataDescripcion, this.view.title);
    }
    , executeValidators() {
      if (!this.isAllValid(this.$v)) {
        EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", this.$t("errors.validof"));
        scrollToForm(this);
      }
    }
    , removeSubstatus(item) {
      this.status.substatus = this.status.substatus.filter((el) => el.code != item.code);
    }
  }
  , validations: {
    status: {
      descripcion: { required, fixMigImp: fixMigImp() }
      , canales: { required }
      , substatus: {}
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/operativos/status/Status.vue